import React from 'react';
import {Choice} from '../types';

type ButtonGroupProps = {
    choices: Choice[];
    value: Choice[];
    onChange: (value: any) => void;
};

export const ButtonGroup: React.FunctionComponent<ButtonGroupProps> = ({
                                                                           choices,
                                                                           value,
                                                                           onChange
                                                                       }) => {

    const choiceSelected = (needle: Choice, haystack: Choice[]) => {
        return (haystack.find((item: Choice) => item.value === needle.value) !== undefined);
    };

    return (
        <div>
            {choices.map((choice: Choice, index: number) => (
                <button key={index}
                        type="button"
                        className={'align-items-center btn-group btn btn-sm mr-2 ' + (choiceSelected(choice, value) ? 'btn-danger' : 'btn-outline-danger')}
                        onClick={() => {
                            let newValue = [];
                            if (choiceSelected(choice, value)) {
                                const idx = value.findIndex((item: Choice) => item.value === choice.value);
                                newValue = [
                                    ...value.slice(0, idx),
                                    ...value.slice(idx + 1)
                                ];
                            } else {
                                newValue = [
                                    ...value,
                                    choice
                                ];
                            }

                            onChange && onChange(newValue);
                        }}
                >
                    {choice.label}
                    {choiceSelected(choice, value) && <i className="far fa-times-circle ml-2"/>}
                </button>
            ))}
        </div>
    );
};